import Vue from 'vue';
import {RepositoryFactory} from '../api/RepositoryFactory';

const moment = require('moment');

export default Vue.mixin({
    data(){
        return {
            moment: moment,
            API_URL: process.env.VUE_APP_API_URL,
            APP_NAME: process.env.VUE_APP_NAME,
        }
    },
    methods : {
        $api: (repo) => RepositoryFactory.get(repo),
        $apiAdmin: (repo) => RepositoryFactory.getAdmin(repo),
        hasRole(...roleNames) {
            return roleNames.findIndex((r) => r.toLowerCase() === this.HOME_USER.role_label.toLowerCase()) > - 1;
        },
    },
    computed : {
        HOME_USER : function () {
            return this.$store.getters.HOME_USER || {};
        },
        ADMIN_USER : function () {
            return this.$store.getters.ADMIN_USER || {};
        }
    }
});